import ChoosePath from './ChoosePath'
import Eligibility from './Eligibility'
import ContactInfo from './ContactInfo'
import Schedule from './Schedule'
import Success from './Success'

export default { ChoosePath, Eligibility, ContactInfo, Schedule, Success }
